import _extends from '../../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import React from 'react';
import { Switch } from 'antd-mobile';

var SwitchWrap = function SwitchWrap(props) {
  var value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/React.createElement(Switch, _extends({
    checked: value,
    onChange: onChange,
    style: {
      '--width': '40px',
      '--height': '22px'
    }
  }, props));
};

export { SwitchWrap as default };
